import React, { Component } from "react";
import { Form, Button, Col, Container } from "react-bootstrap";
// import PhoneInput from "react-phone-number-input";
import { STUDENT } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from 'react-select';
import { useForm,Controller } from "react-hook-form";

const AddressDetails = ({ register, errors,addressType,formObjKey ,control}) => {
  const { details, loader ,studentProfileDetails , statesList } = useSelector((state) => state.student);
  return (
    <>
      { formObjKey ? (
        <Form>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="formAddress"
          >
            <Form.Label>Address</Form.Label>
            <Form.Control
                      type="textarea"
                      name="addressLine"
                      rows={2}
                      {...register(`${formObjKey}.addressLine`)}
                      className={`form-control ${
                        errors[`${formObjKey}`] && errors[`${formObjKey}`].addressLine ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors[`${formObjKey}`] && errors[`${formObjKey}`].addressLine?.message}
                    </span>
          </Form.Group>

          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="formCity"
          >
            <Form.Label>City</Form.Label>
            <Form.Control
                      type="text"
                      name="city"
                      {...register(`${formObjKey}.city`)}
                      className={`form-control ${
                        errors[`${formObjKey}`] && errors[`${formObjKey}`].city ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors[`${formObjKey}`] && errors[`${formObjKey}`].city?.message}
                    </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="formCity"
          >
            <Form.Label>Dist</Form.Label>
            <Form.Control
                      type="text"
                      name="district"
                      {...register(`${formObjKey}.district`)}
                      className={`form-control ${
                        errors[`${formObjKey}`] && errors[`${formObjKey}`].district ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors[`${formObjKey}`] && errors[`${formObjKey}`].district?.message}
                    </span>
                    </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="formState"
          >
            <Form.Label>State</Form.Label>
            <Controller
                  name="StateId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={statesList}
                        className={`${errors[`${formObjKey}`] && errors[`${formObjKey}`].StateId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                      />
                      <span className="invalid-feedback">
                        {errors[`${formObjKey}`] && errors[`${formObjKey}`].StateId?.message}
                      </span>
                    </>
                  )}
                  {...register(`${formObjKey}.StateId`)}
                />
            {/* <Form.Control
              as="select"
              name="StateId"
              {...register(`${formObjKey}.StateId`)}
                      className={`form-control ${
                        errors[`${formObjKey}`] && errors[`${formObjKey}`].StateId ? "is-invalid" : ""
                      }`}
            >
              <option value="">Please Select</option>
              {statesList.map((obj) => (
                <option value={obj.value}>{obj.label}</option>
              ))}
               </Form.Control> */}
                    
                    <span className="invalid-feedback">
                      {errors[`${formObjKey}`] && errors[`${formObjKey}`].StateId?.message}
                    </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="formZip"
          >
            <Form.Label>Zip</Form.Label>
            <Form.Control
                      type="text"
                      name="state"
                      {...register(`${formObjKey}.postalCode`)}
                      className={`form-control ${
                        errors[`${formObjKey}`] && errors[`${formObjKey}`].postalCode ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors[`${formObjKey}`] && errors[`${formObjKey}`].postalCode?.message}
                    </span>
          </Form.Group>
          {addressType === STUDENT ? (
            <>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
                controlId="formZip"
              >
                <Form.Label>Distance From School (kilometers)</Form.Label>
                <Form.Control
                  type="number"
                  name="distanceFromSchool"
                  className={`${errors.distanceFromSchool ? "is-invalid" : ""}`}
                  {...register("distanceFromSchool")}
                />
                <span className="invalid-feedback">
                  {errors.distanceFromSchool?.message}
                </span>
              </Form.Group>
            </>
          ) : null}
        </Form.Row>
      </Form>
      ):(
        <Form>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="formAddress"
          >
            <Form.Label>Address</Form.Label>
            <Form.Control
              type="textarea"
              name="addressLine"
              rows={2}
              className={`${errors.addressLine ? "is-invalid" : ""}`}
              {...register("addressLine")}
            />
            <span className="invalid-feedback">{errors.addressLine?.message}</span>
          </Form.Group>

          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="formCity"
          >
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              name="city"
              className={`${errors.city ? "is-invalid" : ""}`}
              {...register("city")}
            />
            <span className="invalid-feedback">{errors.city?.message}</span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="formCity"
          >
            <Form.Label>Dist</Form.Label>
            <Form.Control
              type="text"
              name="dist"
              className={`${errors.district ? "is-invalid" : ""}`}
              {...register("district")}
            />
            <span className="invalid-feedback">{errors.district?.message}</span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="formState"
          >
            <Form.Label>State</Form.Label>
            <Controller
                  name="StateId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={statesList}
                        className={`${errors.StateId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                      />
                      <span className="invalid-feedback">
                        {errors.StateId?.message}
                      </span>
                    </>
                  )}
                  {...register("StateId")}
                />
            {/* <Form.Control
              as="select"
              name="StateId"
              className={`form-control ${errors.StateId ? "is-invalid" : ""}`}
              {...register("StateId")}
            >
              <option value="">Please Select</option>
              {statesList.map((obj) => (
                <option value={obj.id}>{obj.name}</option>
              ))}
               </Form.Control>
            <span className="invalid-feedback">{errors.StateId?.message}</span> */}
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="formZip"
          >
            <Form.Label>Zip</Form.Label>
            <Form.Control
              type="number"
              name="postalCode"
              className={`${errors.postalCode ? "is-invalid" : ""}`}
              {...register("postalCode")}
            />
            <span className="invalid-feedback">
              {errors.postalCode?.message}
            </span>
          </Form.Group>
          {addressType === STUDENT ? (
            <>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
                controlId="formZip"
              >
                <Form.Label>Distance From School (kilometers)</Form.Label>
                <Form.Control
                  type="number"
                  name="distanceFromSchool"
                  className={`${errors.distanceFromSchool ? "is-invalid" : ""}`}
                  {...register("distanceFromSchool")}
                />
                <span className="invalid-feedback">
                  {errors.distanceFromSchool?.message}
                </span>
              </Form.Group>
            </>
          ) : null}
        </Form.Row>
      </Form>
      )}
    </>
  );
};

export default AddressDetails;
